// client/src/App.js - VERSÃO 100% COMPLETA E CORRIGIDA
import React, { Fragment, useEffect } from 'react';
import {
    BrowserRouter as Router,
    Route,
    Routes,
    useNavigate,
    useLocation
} from 'react-router-dom';
import axios from 'axios';

// Provedores Globais
import AppProviders from './context/AppProviders';

// Layout e Componentes
import Alerts from './components/layout/Alert';
import PrivateRoute from './components/routing/PrivateRoute';
import AcessoNegado from './components/layout/AcessoNegado';

// Páginas de Autenticação
import Login from './components/auth/Login';
import ForgotPasswordPage from './components/auth/ForgotPasswordPage';
import ResetPasswordPage from './components/auth/ResetPasswordPage';
import AssinarAnamnesePublica from './components/anamnese/AssinarAnamnesePublica';
import AssinarContratoPublica from './components/contratos/AssinarContratoPublica';
import ForceChangePasswordPage from './components/auth/ForceChangePasswordPage';
import MyAccountPage from './components/auth/MyAccountPage';
import SubscriptionPage from './components/auth/SubscriptionPage';

// Páginas Principais
import Dashboard from './components/dashboard/Dashboard';
import Fornecedores from './components/fornecedores/Fornecedores';
import Transportadores from './components/transportadores/Transportadores';
import Clientes from './components/clientes/Clientes';
import Contratos from './components/contratos/Contratos';
import Agendamentos from './components/agendamentos/Agendamentos';
import AccountUsers from './components/account/AccountUsers';
import AccountSettings from './components/account/AccountSettings';
import Recursos from './components/recursos/Recursos';
import Servicos from './components/servicos/Servicos';
import ItensVenda from './components/itensVenda/ItensVenda';
import PacotesCliente from './components/pacotesCliente/PacotesCliente';
import HorarioAtendimentoPage from './components/configuracoes/horarios/HorarioAtendimentoPage';
import DisponibilidadePage from './components/configuracoes/disponibilidade/DisponibilidadePage';
import TiposContrato from './components/tiposContrato/TiposContrato';
import GaleriaManagementPage from './components/galeria/GaleriaManagementPage';
import TemplatesPage from './components/templates/TemplatesPage';

// Páginas Novas
import MetodoPagamentoPage from './components/configuracoes/pagamentos/MetodoPagamentoPage';
import EntregaConfigPage from './components/configuracoes/entrega/EntregaConfigPage';
import ComunicacaoManualPage from './components/comunicacao/manual/ComunicacaoManualPage';
import ComunicacaoAutomaticaPage from './components/comunicacao/automatica/ComunicacaoAutomaticaPage';
import ComunicacaoAgendadaPage from './components/comunicacao/agendadas/ComunicacaoAgendadaPage';
import VendasPage from './components/vendas/VendasPage';
import FidelidadePage from './components/fidelidade/FidelidadePage';
import FidelidadeConfigPage from './components/configuracoes/fidelidade/FidelidadeConfigPage';
import ListaEsperaPage from './components/listaEspera/ListaEsperaPage';
import ListaEsperaConfigPage from './components/configuracoes/listaEspera/ListaEsperaConfigPage';
import NotaFiscalPage from './components/notaFiscal/NotaFiscalPage';
import NotaFiscalConfigPage from './components/configuracoes/notaFiscal/NotaFiscalConfigPage';
import PlataformaNotaFiscalPage from './components/plataformaNotaFiscal/PlataformaNotaFiscalPage';
import PlataformaNotaFiscalConfigPage from './components/configuracoes/plataformaNotaFiscal/PlataformaNotaFiscalConfigPage';
import PlataformaBrandingConfigPage from './components/configuracoes/plataformaBranding/PlataformaBrandingConfigPage';
import PlataformaGoogleNegocioConfigPage from './components/configuracoes/plataformaGoogleNegocio/PlataformaGoogleNegocioConfigPage';
import PlataformaGoogleLoginConfigPage from './components/configuracoes/plataformaGoogleLogin/PlataformaGoogleLoginConfigPage';
import PedidosPage from './components/pedidos/PedidosPage';
import OfertasPage from './components/ofertas/OfertasPage';
import CursosPage from './components/cursos/CursosPage';
import Categorias from './components/categorias/Categorias';
import SinaisPage from './components/configuracoes/sinais/SinaisPage';

// ✅ NOVAS PÁGINAS - IMPORTADAS DOS NOVOS COMPONENTES
import ProfissionaisPage from './components/profissionais/ProfissionaisPage';
import ProfissionalManagementDrawer from './components/profissionais/ProfissionalManagementDrawer';
import UnidadesPage from './components/unidades/UnidadesPage';
import UnidadeFormPage from './components/unidades/UnidadeFormPage';
import UnidadeManagementDrawer from './components/unidades/UnidadeManagementDrawer'; // ✅ NOVO IMPORT

// Página Pública
import PublicPageSettings from './components/account/PublicPageSettings';

// Páginas de Indicadores
import FaturamentoReport from './components/indicadores/FaturamentoReport';
import ClientesReport from './components/indicadores/ClientesReport';
import ServicosReport from './components/indicadores/ServicosReport';
import AgendamentosReport from './components/indicadores/AgendamentosReport';
import PagamentosReport from './components/indicadores/PagamentosReport';
import AniversariantesReport from './components/indicadores/AniversariantesReport';
import ComissoesReport from './components/indicadores/ComissoesReport';
import ProdutosReport from './components/indicadores/ProdutosReport';

// Páginas de Plataforma
import FranquiasPage from './components/plataforma/franquias/FranquiasPage';
import FranquiaFormPage from './components/plataforma/franquias/FranquiaFormPage';
import FranquiaUsersPage from './components/plataforma/franquias/FranquiaUsersPage';
import ContasPage from './components/plataforma/contas/ContasPage';
import ContaFormPage from './components/plataforma/contas/ContaFormPage';
import ContaDashboardPage from './components/plataforma/contas/ContaDashboardPage';
import ContaEquipePage from './components/plataforma/contas/ContaEquipePage';
import ContaConfiguracoesPage from './components/plataforma/contas/ContaConfiguracoesPage';
import ContaPublicPageSettings from './components/plataforma/contas/ContaPublicPageSettings';
import PlansContasPage from './components/plataforma/planosContas/PlansContasPage';
import PlansContasFormPage from './components/plataforma/planosContas/PlansContasFormPage';
import PlansFranquiasPage from './components/plataforma/planosFranquias/PlansFranquiasPage';
import PlansFranquiasFormPage from './components/plataforma/planosFranquias/PlansFranquiasFormPage';

// ✅ CORREÇÃO CRÍTICA: IMPORT DO UserManagementDrawer
import UserManagementDrawer from './components/plataforma/users/UserManagementDrawer';

// Páginas do Site Institucional
import ContatosPage from './components/plataforma/siteInstitucional/ContatosPage';
import MensagensContatoPage from './components/plataforma/siteInstitucional/MensagensContatoPage';
import FaqPage from './components/plataforma/siteInstitucional/FaqPage';
import FaqFormPage from './components/plataforma/siteInstitucional/FaqFormPage';
import RedesSociaisPage from './components/plataforma/siteInstitucional/RedesSociaisPage';
import RedesSociaisFormPage from './components/plataforma/siteInstitucional/RedesSociaisFormPage';
import NavegacaoPage from './components/plataforma/siteInstitucional/NavegacaoPage';
import NavegacaoFormPage from './components/plataforma/siteInstitucional/NavegacaoFormPage';
import ConfiguracoesHomePage from './components/plataforma/siteInstitucional/ConfiguracoesHomePage';
import BannersHomePage from './components/plataforma/siteInstitucional/BannersHomePage';
import BannersHomeFormPage from './components/plataforma/siteInstitucional/BannersHomeFormPage';
import ConteudosHomePage from './components/plataforma/siteInstitucional/ConteudosHomePage';
import PaginasListPage from './components/plataforma/siteInstitucional/PaginasListPage';
import PaginasFormPage from './components/plataforma/siteInstitucional/PaginasFormPage';
import TestimonialsManagementPage from './components/plataforma/siteInstitucional/TestimonialsManagementPage';
import MyTestimonialsPage from './components/auth/MyTestimonialsPage';
import AccountTestimonialsPage from './components/plataforma/siteInstitucional/AccountTestimonialsPage';

// Páginas de Políticas e Termos
import PoliciesListPage from './components/plataforma/politicasETermos/PoliciesListPage';
import PolicyFormPage from './components/plataforma/politicasETermos/PolicyFormPage';

// Novas Páginas
import NotificacoesConfigPage from './components/configuracoes/notificacoes/NotificacoesConfigPage';
import MinhasNotificacoesPage from './components/auth/MinhasNotificacoesPage';
import PermissoesPage from './components/plataforma/permissoes/PermissoesPage';
import FinanceiroPage from './components/configuracoes/financeiro/FinanceiroPage';
import IntegracoesConfigPage from './components/configuracoes/integracoes/IntegracoesConfigPage';
import CreditosPacotesAdminPage from './components/configuracoes/creditos/CreditosPacotesAdminPage';
import CatalogoModeloPage from './components/catalogoModelo/CatalogoModeloPage';
import ImportarCatalogoPage from './components/catalogoModelo/ImportarCatalogoPage';
import AcessoSuporteConfigPage from './components/configuracoes/acessoSuporte/AcessoSuporteConfigPage';

// Auditoria
import LogsPage from './components/auditoria/LogsPage';
import AtividadesPage from './components/auditoria/AtividadesPage';

// Documentos (histórico de recibos/certificados/anamneses gerados)
import RecibosHistoricoPage from './components/documentos/RecibosHistoricoPage';
import CertificadosHistoricoPage from './components/documentos/CertificadosHistoricoPage';
import AnamnesesHistoricoPage from './components/documentos/AnamnesesHistoricoPage';

axios.defaults.baseURL = process.env.REACT_APP_API_URL || 'http://localhost:50000/api/v1';

const AxiosInterceptorSetup = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const publicEndpoints = [
            '/auth/login',
            '/auth/register',
            '/auth/forgot-password',
            '/auth/force-change-password',
            '/institucional/pages',
            '/institucional/pages/slug/',
            '/institucional/home-config',
            '/institucional/banners',
            '/institucional/faqs',
            '/institucional/faqs/category/',
            '/institucional/contents',
            '/institucional/contents/slug/',
            '/institucional/testimonials',
            '/institucional/contact-info',
            '/institucional/social-configs',
            '/institucional/contact',
        ];

        const isPublicRoute = (url) => {
            return publicEndpoints.some(endpoint => url.startsWith(endpoint));
        };

        const requestInterceptor = axios.interceptors.request.use(
            (config) => {
                // ✅ SEGURANÇA: ver mesmo header em services/api.js — identifica
                // a chamada como vinda do painel web pro backend bloquear
                // scope 'conta' aqui (exclusivo pra matriz/franquia). Aplicado
                // mesmo em rotas públicas (não depende de token).
                config.headers['X-Client-Platform'] = 'web';

                if (!isPublicRoute(config.url)) {
                    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
                    if (token) {
                        config.headers.Authorization = `Bearer ${token}`;
                    }
                }
                return config;
            },
            (error) => Promise.reject(error)
        );

        const responseInterceptor = axios.interceptors.response.use(
            (response) => response,
            (error) => {
                if (error.response?.status === 403) {
                    const currentPath = window.location.pathname;
                    const publicPaths = ['/login', '/register', '/assinatura', '/forgot-password', '/force-change-password'];

                    if (!publicPaths.includes(currentPath) && !location.pathname.startsWith('/site-institucional')) {
                        navigate(`/assinatura?redirect=${encodeURIComponent(currentPath)}`);
                    }
                }
                return Promise.reject(error);
            }
        );

        return () => {
            axios.interceptors.request.eject(requestInterceptor);
            axios.interceptors.response.eject(responseInterceptor);
        };
    }, [navigate, location.pathname]);

    return null;
};

const App = () => {
    return (
        <AppProviders>
            <Router>
                <Fragment>
                    <Alerts />
                    <AxiosInterceptorSetup />
                    <Routes>
                        {/* Rotas Públicas */}
                        <Route path="/login" element={<Login />} />
                        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                        <Route path="/resetpassword/:resettoken" element={<ResetPasswordPage />} />
                        <Route path="/anamnese/assinar/:token" element={<AssinarAnamnesePublica />} />
                        <Route path="/contrato/assinar/:token" element={<AssinarContratoPublica />} />
                        <Route path="/force-change-password" element={<ForceChangePasswordPage />} />
                        {/* Rotas Protegidas - Todas as Roles */}
                        <Route element={<PrivateRoute />}>
                            <Route path="/" element={<Dashboard />} />
                            <Route path="/assinatura" element={<SubscriptionPage />} />
                            <Route path="/agendamentos" element={<Agendamentos />} />

                            {/* Vendas e Pedidos */}
                            <Route path="/vendas" element={<VendasPage />} />
                            <Route path="/pedidos" element={<PedidosPage />} />
                            <Route path="/fidelidade" element={<FidelidadePage />} />
                            <Route path="/lista-espera" element={<ListaEsperaPage />} />
                            <Route path="/nota-fiscal" element={<NotaFiscalPage />} />

                            {/* Cadastros Gerais */}
                            <Route path="/contratos" element={<Contratos />} />
                            <Route path="/cadastros/clientes" element={<Clientes />} />
                            <Route path="/cadastros/categorias" element={<Categorias />} />
                            <Route path="/cadastros/fornecedores" element={<Fornecedores />} />
                            <Route path="/cadastros/transportadores" element={<Transportadores />} />
                            <Route path="/cadastros/recursos" element={<Recursos />} />
                            <Route path="/cadastros/servicos" element={<Servicos />} />
                            <Route path="/cadastros/itens-venda" element={<ItensVenda />} />
                            <Route path="/cadastros/catalogo-modelo" element={<ImportarCatalogoPage />} />
                            <Route path="/cadastros/ofertas" element={<OfertasPage />} />
                            <Route path="/cadastros/cursos" element={<CursosPage />} />
                            <Route path="/cadastros/pacotes-cliente" element={<PacotesCliente />} />
                            <Route path="/cadastros/tipos-contrato" element={<TiposContrato />} />
                            
                            {/* Documentos (histórico de instâncias geradas — não confundir com Templates) */}
                            <Route path="/documentos/recibos" element={<RecibosHistoricoPage />} />
                            <Route path="/documentos/certificados" element={<CertificadosHistoricoPage />} />
                            <Route path="/documentos/anamneses" element={<AnamnesesHistoricoPage />} />

                            {/* Templates e Configs */}
                            <Route path="/templates/:tipo" element={<TemplatesPage />} />
                            <Route path="/configuracoes/horarios" element={<HorarioAtendimentoPage />} />
                            <Route path="/configuracoes/disponibilidade" element={<DisponibilidadePage />} />
                            <Route path="/configuracoes/pagamentos" element={<MetodoPagamentoPage />} />
                            <Route path="/configuracoes/sinais" element={<SinaisPage />} />
                            <Route path="/configuracoes/entrega-retirada" element={<EntregaConfigPage />} />
                            <Route path="/configuracoes/comunicacao/manual" element={<ComunicacaoManualPage />} />
                            <Route path="/configuracoes/comunicacao/automatica" element={<ComunicacaoAutomaticaPage />} />
                            <Route path="/configuracoes/comunicacao/agendadas" element={<ComunicacaoAgendadaPage />} />
                            <Route path="/configuracoes/notificacoes" element={<NotificacoesConfigPage />} />
                            <Route path="/configuracoes/integracoes" element={<IntegracoesConfigPage />} />
                            <Route path="/configuracoes/financeiro" element={<FinanceiroPage />} />
                            <Route path="/configuracoes/fidelidade" element={<FidelidadeConfigPage />} />
                            <Route path="/configuracoes/lista-espera" element={<ListaEsperaConfigPage />} />
                            <Route path="/configuracoes/nota-fiscal" element={<NotaFiscalConfigPage />} />
                            <Route path="/meu-perfil/notificacoes" element={<MinhasNotificacoesPage />} />
                        </Route>

                        {/* Acesso de Suporte — só franquia/conta CONCEDEM acesso (matriz é sempre quem usa via impersonate) */}
                        <Route element={<PrivateRoute roles={['franquia_admin', 'conta_admin']} />}>
                            <Route path="/configuracoes/acesso-suporte" element={<AcessoSuporteConfigPage />} />
                        </Route>

                        <Route element={<PrivateRoute />}>
                            {/* ✅ ROTAS DE MINHA CONTA - COMPLETAS */}
                            {/* Usuários (apenas dados básicos) */}
                            <Route path="/minha-conta/usuarios" element={<AccountUsers />} />
                            <Route path="/minha-conta/usuarios/novo" element={<UserManagementDrawer />} />
                            <Route path="/minha-conta/usuarios/:userId/editar" element={<UserManagementDrawer />} />
                            
                            {/* ✅ Profissionais - Lista e Gerenciamento */}
                            <Route path="/minha-conta/profissionais" element={<ProfissionaisPage />} />
                            <Route path="/minha-conta/profissionais/:userId/editar" element={<ProfissionalManagementDrawer />} />
                            
                            {/* ✅ Unidades - CRUD completo */}
                            <Route path="/minha-conta/unidades" element={<UnidadesPage />} />
                            <Route path="/minha-conta/unidades/nova" element={<UnidadeFormPage />} />
                            <Route path="/minha-conta/unidades/:unidadeId/editar" element={<UnidadeFormPage />} />
                            
                            {/* ✅ NOVA ROTA: Gerenciamento de Unidade com Abas */}
                            <Route path="/minha-conta/unidades/:unidadeId/gerenciar" element={<UnidadeManagementDrawer />} />
                            
                            {/* ✅ Configurações da Conta */}
                            <Route path="/minha-conta/config" element={<AccountSettings />} />
                            <Route path="/minha-conta/pagina-publica" element={<PublicPageSettings />} />
                            
                            {/* Perfil Pessoal */}
                            <Route path="/meu-perfil/minha-conta" element={<MyAccountPage />} />
                            <Route path="/minha-conta/depoimentos" element={<MyTestimonialsPage />} />
                            <Route path="/minha-conta/depoimentos-da-conta" element={<AccountTestimonialsPage />} />
                            
                            {/* Indicadores */}
                            <Route path="/indicadores/faturamento" element={<FaturamentoReport />} />
                            <Route path="/indicadores/clientes" element={<ClientesReport />} />
                            <Route path="/indicadores/servicos" element={<ServicosReport />} />
                            <Route path="/indicadores/agendamentos" element={<AgendamentosReport />} />
                            <Route path="/indicadores/pagamentos" element={<PagamentosReport />} />
                            <Route path="/indicadores/aniversariantes" element={<AniversariantesReport />} />
                            <Route path="/indicadores/comissoes" element={<ComissoesReport />} />
                            <Route path="/indicadores/produtos" element={<ProdutosReport />} />
                            
                            <Route path="/acesso-negado" element={<AcessoNegado />} />
                        </Route>

                        {/* Site institucional "geral" (matriz + franquia + conta, nunca cliente) */}
                        <Route element={<PrivateRoute roles={['matriz_admin', 'franquia_admin', 'conta_admin']} />}>
                            <Route path="/site-institucional/faq" element={<FaqPage />} />
                            <Route path="/site-institucional/faq/nova" element={<FaqFormPage />} />
                            <Route path="/site-institucional/faq/editar/:id" element={<FaqFormPage />} />
                            <Route path="/site-institucional/redes-sociais" element={<RedesSociaisPage />} />
                            <Route path="/site-institucional/redes-sociais/nova" element={<RedesSociaisFormPage />} />
                            <Route path="/site-institucional/redes-sociais/editar/:id" element={<RedesSociaisFormPage />} />
                            <Route path="/site-institucional/navegacao" element={<NavegacaoPage />} />
                            <Route path="/site-institucional/navegacao/nova" element={<NavegacaoFormPage />} />
                            <Route path="/site-institucional/navegacao/editar/:id" element={<NavegacaoFormPage />} />
                            <Route path="/site-institucional/configuracoes-home" element={<ConfiguracoesHomePage />} />
                            <Route path="/site-institucional/banners-home" element={<BannersHomePage />} />
                            <Route path="/site-institucional/banners/novo" element={<BannersHomeFormPage />} />
                            <Route path="/site-institucional/banners/editar/:id" element={<BannersHomeFormPage />} />
                            <Route path="/site-institucional/conteudos-home" element={<ConteudosHomePage />} />
                            <Route path="/site-institucional/mensagens" element={<MensagensContatoPage />} />
                        </Route>

                        {/* Exclusivo Matriz (nao Franquia) */}
                        <Route element={<PrivateRoute roles={['matriz_admin']} />}>
                            <Route path="/configuracoes/creditos-comunicacao" element={<CreditosPacotesAdminPage />} />
                        </Route>

                        {/* ✅ CORREÇÃO SEGURANÇA: PrivateRoute só compara NÍVEL
                            hierárquico de scope (matriz < franquia < conta...),
                            não a lista exata de roles — um bloco único com
                            roles={['matriz_admin','franquia_admin']} deixava
                            franquia_admin alcançar por URL direta páginas que
                            o Sidebar já esconde por serem matriz-only (gestão
                            de TODAS as franquias, planos globais, galeria
                            global, CMS institucional, permissões, auditoria).
                            Dividido em dois blocos: o que franquia legitimamente
                            gerencia (contas da PRÓPRIA franquia, acessadas via
                            :franquiaId na URL) e o que é exclusivo da matriz. */}

                        {/* Compartilhado matriz + franquia — franquia só gerencia
                            as contas vinculadas à própria franquia (:franquiaId) */}
                        <Route element={<PrivateRoute roles={['matriz_admin', 'franquia_admin']} />}>
                            {/* Contas de uma Franquia específica */}
                            <Route path="/franquias/:franquiaId/contas" element={<ContasPage />} />
                            <Route path="/franquias/:franquiaId/contas/novo" element={<ContaFormPage />} />
                            <Route path="/franquias/:franquiaId/contas/:contaId/editar" element={<ContaFormPage />} />

                            {/* Dashboard e Equipe de Conta Específica */}
                            <Route path="/contas/:id/dashboard" element={<ContaDashboardPage />} />
                            <Route path="/contas/:id/equipe" element={<ContaEquipePage />} />
                            <Route path="/contas/:contaId/equipe/novo" element={<UserManagementDrawer />} />
                            <Route path="/contas/:contaId/equipe/:userId/editar" element={<UserManagementDrawer />} />
                            <Route path="/contas/:id/configuracoes" element={<ContaConfiguracoesPage />} />
                            <Route path="/contas/:id/pagina-publica" element={<ContaPublicPageSettings />} />
                        </Route>

                        {/* Exclusivo Matriz — gestão de TODAS as franquias/contas,
                            planos globais, CMS institucional, permissões, auditoria */}
                        <Route element={<PrivateRoute roles={['matriz_admin']} />}>
                            {/* Franquias */}
                            <Route path="/franquias" element={<FranquiasPage />} />
                            <Route path="/franquias/novo" element={<FranquiaFormPage />} />
                            <Route path="/franquias/:id/editar" element={<FranquiaFormPage />} />

                            {/* Admins de Franquia */}
                            <Route path="/franquias/:franquiaId/admins" element={<FranquiaUsersPage />} />
                            <Route path="/franquias/:franquiaId/admins/novo" element={<UserManagementDrawer />} />
                            <Route path="/franquias/:franquiaId/admins/:userId/editar" element={<UserManagementDrawer />} />

                            {/* Contas (Acesso direto Matriz) */}
                            <Route path="/plataforma/contas" element={<ContasPage />} />
                            <Route path="/contas/novo" element={<ContaFormPage />} />
                            <Route path="/contas/:contaId/editar" element={<ContaFormPage />} />

                            {/* Planos */}
                            <Route path="/plataforma/planos-contas" element={<PlansContasPage />} />
                            <Route path="/plataforma/planos-contas/novo" element={<PlansContasFormPage />} />
                            <Route path="/plataforma/planos-contas/:id/editar" element={<PlansContasFormPage />} />
                            <Route path="/plataforma/planos-franquias" element={<PlansFranquiasPage />} />
                            <Route path="/plataforma/planos-franquias/novo" element={<PlansFranquiasFormPage />} />
                            <Route path="/plataforma/planos-franquias/:id/editar" element={<PlansFranquiasFormPage />} />

                            <Route path="/galeria/gerenciamento" element={<GaleriaManagementPage />} />

                            {/* Nota Fiscal da Mensalidade — matriz emitindo em nome da
                                própria plataforma, cobrando Franquia/Conta */}
                            <Route path="/plataforma/notas-fiscais" element={<PlataformaNotaFiscalPage />} />
                            <Route path="/configuracoes/nota-fiscal-plataforma" element={<PlataformaNotaFiscalConfigPage />} />

                            {/* Logo da Plataforma — identidade visual exibida na sidebar
                                web e no drawer mobile, pra todos os tenants */}
                            <Route path="/configuracoes/branding-plataforma" element={<PlataformaBrandingConfigPage />} />

                            {/* Google Meu Negócio — credenciais OAuth da plataforma,
                                consumidas por toda Conta que conectar (fluxo no mobile) */}
                            <Route path="/configuracoes/google-negocio" element={<PlataformaGoogleNegocioConfigPage />} />

                            {/* Login com Google — Client ID pro cliente final entrar
                                pelo site/conta com a própria conta Google */}
                            <Route path="/configuracoes/google-login" element={<PlataformaGoogleLoginConfigPage />} />

                            {/* Site Institucional - Apenas Matriz */}
                            <Route path="/site-institucional/contatos" element={<ContatosPage />} />
                            <Route path="/site-institucional/paginas" element={<PaginasListPage />} />
                            <Route path="/site-institucional/paginas/nova" element={<PaginasFormPage />} />
                            <Route path="/site-institucional/paginas/editar/:id" element={<PaginasFormPage />} />
                            <Route path="/site-institucional/politicas" element={<PoliciesListPage />} />
                            <Route path="/site-institucional/politicas/nova" element={<PolicyFormPage />} />
                            <Route path="/site-institucional/politicas/editar/:id" element={<PolicyFormPage />} />
                            <Route path="/site-institucional/depoimentos" element={<TestimonialsManagementPage />} />
                            <Route path="/plataforma/permissoes" element={<PermissoesPage />} />
                            <Route path="/plataforma/catalogo-modelo" element={<CatalogoModeloPage />} />

                            {/* Auditoria */}
                            <Route path="/auditoria/logs" element={<LogsPage />} />
                            <Route path="/auditoria/atividades" element={<AtividadesPage />} />
                        </Route>

                        {/* Rota 404 */}
                        <Route path="*" element={
                            <div className="flex items-center justify-center h-screen bg-gray-50">
                                <div className="text-center">
                                    <h1 className="text-6xl font-bold text-gray-300">404</h1>
                                    <p className="text-xl text-gray-600 mt-4">Página não encontrada</p>
                                </div>
                            </div>
                        } />
                    </Routes>
                </Fragment>
            </Router>
        </AppProviders>
    );
};

export default App;